import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { IAppOnlyStore } from '../../../stores/AllStores';
import { Modal } from '../../popup';
import { Button, EButtonType } from '../../action';
import { ChangePasswordStatus } from '../../../stores/ChangePassword';

// Styles
const s = require('./ChangePasswordModal.css');

// Component
@inject('store')
@observer
export class ChangePasswordModal extends React.Component<IAppOnlyStore, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        const { changePassword: { passwords, changePasswordStatus, showChangePasswordModal } } = this.props.store;

        return (
            <Modal
                show={showChangePasswordModal}
                title="Change your password"
                onClose={this.handleModalClose}
                closeLabel="Cancel password change"
            >
                <form className={s.form} onSubmit={this.handleNewPasswordSubmit}>

                    <div className={s.fields}>
                        <label>
                            <p>Current password:</p>
                            <input
                                type="password"
                                value={passwords.currentPassword}
                                onChange={this.handlePasswordChange('currentPassword')}
                            />
                        </label>

                        <label>
                            <p>New password:</p>
                            <input
                                type="password"
                                value={passwords.newPassword}
                                onChange={this.handlePasswordChange('newPassword')}
                            />
                        </label>

                        <label>
                            <p>Repeat new password:</p>
                            <input
                                type="password"
                                value={passwords.newPasswordRepeat}
                                onChange={this.handlePasswordChange('newPasswordRepeat')}
                            />
                        </label>
                    </div>

                    <div className={s.buttonContainer}>
                        <Button
                            onClick={this.handleNewPasswordSubmit}
                            inBox={true}
                            type={
                                changePasswordStatus === ChangePasswordStatus.Default
                                    ? EButtonType.Action
                                    : changePasswordStatus === ChangePasswordStatus.Success
                                        ? EButtonType.Success
                                        : changePasswordStatus === ChangePasswordStatus.Updating
                                            ? EButtonType.Default
                                            : EButtonType.Important
                            }
                        >
                            {
                                changePasswordStatus === ChangePasswordStatus.ErrorOther
                                    ? 'Could not change password, try again'
                                    : changePasswordStatus === ChangePasswordStatus.ErrorAllFieldsAreRequired
                                        ? 'All fields are required, enter passwords and try again'
                                        : changePasswordStatus === ChangePasswordStatus.ErrorNewPasswordsDoNotMatch
                                            ? 'Entered new passwords do not match each other, try again'
                                            : changePasswordStatus === ChangePasswordStatus.Success
                                                ? 'Password changed'
                                                : changePasswordStatus === ChangePasswordStatus.Updating
                                                    ? 'Updating password'
                                                    : 'Change password'
                            }
                        </Button>
                    </div>

                </form>
            </Modal>
        );
    }

    private handleModalClose = () => {
        this.props.store.changePassword.hideChangePasswordModal();
    }

    private handlePasswordChange =
        (type: 'currentPassword' | 'newPassword' | 'newPasswordRepeat') =>
        (e: React.ChangeEvent<HTMLInputElement>) => {
            this.props.store.changePassword.updatePassword(e.target.value, type);
    }

    private handleNewPasswordSubmit = (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        if (this.props.store.changePassword.changePasswordStatus !== ChangePasswordStatus.Updating) {
            this.props.store.changePassword.submitPasswordChange(this.props.store.user.id);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/ChangePasswordModal/ChangePasswordModal.tsx